import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    if (onClick) onClick();else window.open('https://www.tres33group.com/cart/43089344135229:1', '_blank');
  }} className={`bg-amber text-white font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-yellow-600 transition-colors text-xl md:text-2xl w-full md:w-auto text-center block mx-auto ${className}`} data-id="element-415">
      {children}
    </motion.button>;
}